export default "__VITE_ASSET__BjcWz1cx__"